import { ISchema, PaywallComponentProps } from '../../@types'

// Variant B — highlight the timer.
export default (schema: ISchema): ISchema => ({
	...schema,
	overrides: {
		...schema.overrides,
		PaywallCountdownQuickAccess: (): PaywallComponentProps.CountdownQuickAccess => ({
			theme: 'timer',
			text: '',
			buttonEvent: 'scrollToPlanPicker',
		}),
	},
})
